package playground.gradient.ui

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.spring
import androidx.compose.animation.scaleIn
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectDragGestures
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import playground.gradient.data.ColorStop
import playground.gradient.generateInBetweenColor

@Composable
fun ColorStopEditor(
    modifier: Modifier = Modifier,
    stops: List<ColorStop>,
    stopIndex: Long,
    onColorStopSelected: (Long) -> Unit,
    onColorStopsChanged: (List<ColorStop>) -> Unit
) {
    var intSize by remember { mutableStateOf(IntSize.Zero) }
    val stopsState by rememberUpdatedState(stops)
    Box(
        modifier = modifier
            .fillMaxWidth()
            .onSizeChanged { intSize = it }
            .height(24.dp)
            .pointerInput(Unit) {
                detectTapGestures(
                    onTap = { offset ->
                        val newStop = offset.x / intSize.width
                        var newColor = Color.Red

                        if (stopsState.size == 1) newColor = stopsState.first().color
                        else if (stopsState.size > 1) {
                            val sortedStops = stopsState.sortedBy { it.stop }
                            if (newStop < sortedStops.first().stop) newColor =
                                sortedStops.first().color
                            else if (newStop > sortedStops.last().stop) newColor =
                                sortedStops.last().color
                            else {
                                val leftIndex =
                                    sortedStops.indexOfLast { it.stop < newStop }
                                val rightIndex = leftIndex + 1

                                newColor = generateInBetweenColor(
                                    sortedStops[leftIndex].color,
                                    sortedStops[rightIndex].color,
                                    (newStop - sortedStops[leftIndex].stop) / (sortedStops[rightIndex].stop - sortedStops[leftIndex].stop)
                                )

//                                newColor = lerp(
//                                    sortedStops[leftIndex].color,
//                                    sortedStops[rightIndex].color,
//                                    (newStop - sortedStops[leftIndex].stop) / (sortedStops[rightIndex].stop - sortedStops[leftIndex].stop)
//                                )
                            }

                        }
                        onColorStopsChanged(stopsState.plus(ColorStop(newStop, newColor)))
                    }
                )
            }
            .background(
                color = Color.White.copy(alpha = .15f),
                shape = CircleShape
            ),
        contentAlignment = Alignment.CenterStart,
    ) {
        stopsState.forEachIndexed { index, stop ->
            key(stop.id) {
                var visible by remember { mutableStateOf(false) }
                LaunchedEffect(Unit) { visible = true }
                Row(
                    Modifier
                        .offset {
                            IntOffset(
                                x = (intSize.width * stop.stop).toInt() - 12.dp.roundToPx(),
                                y = 0,
                            )
                        }
                ) {
                    AnimatedVisibility(
                        visible = visible,
                        enter = scaleIn(
                            spring(
                                dampingRatio = Spring.DampingRatioMediumBouncy
                            )
                        )
                    ) {
                        Box(
                            Modifier
                                .pointerHoverIcon(PointerIcon.Hand)
                                .pointerInput(Unit) {
                                    detectTapGestures(
                                        onDoubleTap = {
                                            if (stopsState.size > 2) {
                                                onColorStopsChanged(
                                                    stopsState.filter {
                                                        it.id != stop.id
                                                    }
                                                )
                                            }
                                        },
                                        onPress = {
                                            onColorStopSelected(stop.id)
                                        }
                                    ) {
                                        onColorStopSelected(stop.id)
                                    }
                                }
                                .pointerInput(Unit) {
                                    detectDragGestures { _, dragAmount ->
                                        onColorStopsChanged(
                                            stopsState.map {
                                                if (it.id == stop.id) {
                                                    it.copy(
                                                        stop = (it.stop + (dragAmount.x / intSize.width)).coerceIn(0f..1f)
                                                    )
                                                } else it
                                            }
                                        )
                                    }
                                }
                                .border(
                                    1.dp,
                                    Color.White.copy(alpha = if (stop.id == stopIndex) 1f else .1f),
                                    CircleShape
                                )
                                .padding(3.dp)
                                .background(
                                    color = stop.color,
                                    shape = CircleShape,
                                )
                                .size(16.dp)
                        )
                    }
                }
            }
        }
    }
}